import { byLocale } from './dyanamicLocale';

const getInputsByLocale = (
  locale,
  {
    firstNameInput,
    lastNameInput,
    personalIdInput,
    payrollIdInput,
    emailInput,
    phoneInput,
    bankAccountInput,
    ibanInput,
    salaryTypeInput,
    salaryInput,
    employeeStatusInput,
    startDateInput,
    contractEndInput,
    subsidiaryInput,
    collectiveIdsInput,
    workingTimePercentageInput
  },
  fields,
  onValuesChange,
  bankEntities
) =>
  byLocale(locale, bankEntities)(
    [
      firstNameInput,
      lastNameInput,
      personalIdInput,
      payrollIdInput,
      emailInput,
      phoneInput,
      bankAccountInput,
      ibanInput,
      salaryTypeInput,
      salaryInput,
      employeeStatusInput,
      startDateInput,
      contractEndInput,
      subsidiaryInput,
      collectiveIdsInput,
      workingTimePercentageInput
    ].filter(Boolean),
    fields,
    onValuesChange,
    bankEntities
  );

export default getInputsByLocale;
